/* System defined core library */
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/* User defined library/components */
import { BootstrapParams } from '../../../bootstrap-params';
import { WINDOW } from './window.service';


@Injectable()
export class BingMapsService {
  private promise: any;
  private url = 'https://www.bing.com/api/maps/mapcontrol?callback=__onBingLoaded&key=';

  constructor(
    @Inject(DOCUMENT) private _documentRef: Document,
    @Inject(WINDOW) private _windowRef: Window,
    private bootstrapParams: BootstrapParams) {

    this.url += this.bootstrapParams.bingMapKey;
  }

  public load() {
    // First time 'load' is called?
    if (!this.promise) {

      // Make promise to load
      this.promise = new Promise(resolve => {

        // Set callback for when bing maps is loaded.
        this._windowRef['__onBingLoaded'] = (ev: any) => {
          resolve('Bing Maps API loaded');
        };

        const node = this._documentRef.createElement('script');
        node.src = this.url;
        node.type = 'text/javascript';
        node.async = true;
        node.defer = true;
        this._documentRef.getElementsByTagName('head')[0].appendChild(node);
      });
    }

    // Always return promise. When 'load' is called many times, the promise is already resolved.
    return this.promise;
  }
}